import { requests } from '../apiAgent';

interface SaveWorkshiftBusinessUnitBody {
    startDate: string;
    endDate: string;
    businessUnitId: number;
    employeeIds: (string | number)[];
}

interface DisassociateWorkshiftBusinessUnitBody {
    workshiftSchedulingsBusinessUnitsIds: number[];
}

export const WorkshiftsSchedulingBusinessUnitAPI = {
    saveWorkshiftBusinessUnit: (body: SaveWorkshiftBusinessUnitBody) => {
        return requests
            .post(
                '/jerusalem/api/v2.0.0/workshift-schedulings/associate-business-units',
                body
            )
            .then((res: any) => res);
    },
    disassociateWorkshiftBusinessUnit: (
        body: DisassociateWorkshiftBusinessUnitBody
    ) => {
        return requests
            .deleteWithBody(
                '/jerusalem/api/v2.0.0/workshift-schedulings/disassociate-business-units',
                body
            )
            .then((res: any) => res);
    },
};
